import ddt from '@wix/da-ddt';
import pick from 'lodash/pick';
import getFieldsForEvent from './eventRegistry';
import { BiEventType } from './constants';
const logger = ddt.createLogger('bilogger');
export function validateEvent(event) {
    const eventFields = Object.keys(event);
    const eventId = event['evid'];
    // Test event is literally whatever
    if (eventId === BiEventType.TEST) {
        return event;
    }
    if (!eventId) {
        logger.error('Event is missing evid', event);
        return event;
    }
    const registry = getFieldsForEvent(eventId);
    if (!registry) {
        logger.error('Event missing from registry - remember to add it!!', event);
        return event;
    }
    const missingRequired = registry.requiredFields.filter((field)=>!eventFields.includes(field));
    if (missingRequired.length) {
        logger.warn('Event missing required fields', {
            event,
            missingRequired
        });
    }
    const allKnownFields = [
        ...registry.requiredFields,
        ...registry.optionalFields
    ];
    const unknownFields = eventFields.filter((field)=>!allKnownFields.includes(field));
    if (unknownFields.length) {
        logger.warn(`Event (evid=${eventId}) has unknown fields: ${unknownFields}`, {
            event,
            unknownFields
        });
        return pick(event, allKnownFields);
    }
    return event;
}
